// =============================================
// NÓ: INPUT (CAPTURAR ENTRADA) - MOBILE FIRST
// =============================================
// Arquivo: InputNode.tsx
// Descrição: Nó para capturar entrada do usuário - otimizado para touch
// =============================================

import React from 'react';
import { Handle, Position } from 'reactflow';
import ActionsBadge from './ActionsBadge';
import './NodeStyles.css';

interface InputNodeProps {
  data: {
    label?: string;
    inputType?: 'text' | 'number' | 'image' | 'location' | 'audio' | 'video';
    variableName?: string;
    actions?: {
      input?: any[];
      output?: any[];
    };
  };
  selected?: boolean;
}

const InputNode: React.FC<InputNodeProps> = ({ data, selected }) => {
  const getIcon = () => {
    switch (data.inputType) {
      case 'number': return 'fa-hashtag';
      case 'image': return 'fa-camera';
      case 'location': return 'fa-map-marked-alt';
      case 'audio': return 'fa-microphone';
      case 'video': return 'fa-video';
      default: return 'fa-keyboard';
    }
  };

  return (
    <div className={`custom-node input-node ${selected ? 'selected' : ''}`}>
      <Handle
        type="target"
        position={Position.Top}
        id="input-input"
        className="node-handle target-handle"
      />
      <div className="node-icon">
        <i className={`fas ${getIcon()}`}></i>
      </div>
      <div className="node-content">
        <div className="node-label">{data.label || 'Capturar Entrada'}</div>
        {data.variableName && (
          <div className="node-preview">
            <i className="fas fa-code"></i>
            <span>{data.variableName}</span>
          </div>
        )}
        <ActionsBadge actions={data.actions} />
      </div>
      <Handle
        type="source"
        position={Position.Bottom}
        id="input-output"
        className="node-handle source-handle"
      />
    </div>
  );
};

export default InputNode;
